import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-hot-toast'
import { AdminTariffService } from '@/shared/api'

const KEYS = {
  list: (params?: unknown) => ['tariffs', 'list', params],
  details: (id: number) => ['tariffs', 'details', id],
  courierSummary: (courierId: number) => ['tariffs', 'courier-summary', courierId],
}

export function useTariffs(params?: Record<string, unknown>) {
  return useQuery({
    queryKey: KEYS.list(params),
    queryFn: () => AdminTariffService.list(params),
    staleTime: 60000,
  })
}

export function useTariff(id: number) {
  return useQuery({
    queryKey: KEYS.details(id),
    queryFn: () => AdminTariffService.details(id),
    enabled: !!id,
  })
}

export function useCourierTariffSummary(courierId: number) {
  return useQuery({
    queryKey: KEYS.courierSummary(courierId),
    queryFn: () => AdminTariffService.courierSummary(courierId),
    enabled: !!courierId,
  })
}

export function useTariffMutation<TInput>(
  action: (input: TInput) => Promise<unknown>,
  message: string
) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: action,
    onSuccess: () => {
      toast.success(message)
      queryClient.invalidateQueries({ queryKey: ['tariffs'] })
    },
    onError: (error: { alreadyToasted?: boolean; detail?: string }) => {
      if (!error?.alreadyToasted) toast.error(error?.detail || 'Ошибка')
    },
  })
}
